module.exports = __webpack_public_path__ + "img/instagram_icon.14ab38ba.png";